import type { PaymentMethod } from '../../stores/usePaymentMethodsStore';

/**
 * Id fijo de la opción «Crédito» del sistema (no viene de `payment_methods`).
 * Debe ser distinto de UUID y estable entre sesiones.
 */
export const METODO_PAGO_SISTEMA_CREDITO_ID = '__clientelo_credito__' as const;

/** Fila mínima para armar el wizard: siempre al final de la lista de métodos. */
export function metodoPagoSistemaCredito(empresaId: string): PaymentMethod {
  const now = new Date().toISOString();
  return {
    id: METODO_PAGO_SISTEMA_CREDITO_ID,
    empresa_id: empresaId,
    method_type: 'credito',
    method_name: 'Crédito',
    description: 'Venta a crédito (opción fija; no se configura con otros métodos).',
    account_info: {},
    icon: '🧾',
    is_active: true,
    display_order: 9999,
    show_on_invoices: true,
    show_on_quotes: true,
    created_at: now,
    updated_at: now,
  };
}
